import "@/assets/js/jquery.kerning.min";
import "@/assets/js/cssua.min";

import { sync } from "vuex-router-sync";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as Constants from "./Constants";
import SearchCommon from "./components/common/SearchCommon.vue";
import SearchCommonDetail from "./components/common/SearchCommonDetail.vue";

import VueVisible from "vue-visible";

Vue.use(VueVisible);

Vue.component("SearchCommon", SearchCommon);
Vue.component("SearchCommonDetail", SearchCommonDetail);
require("es6-promise/auto");

if (process.env.NODE_ENV === "development") {
  require.ensure([], () => {
    const lib = require("../basic_auth.js").default;
    Constants.auth.set(lib);
    init();
  });
} else {
  init();
}

function init() {
  Vue.config.productionTip = false;
  router.afterEach((to, from) => {
    if (from.name) {
      window.gtag('config', 'UA-123326648-1', {'page_path': to.path});
    }
    if (to.meta.jsonPath) {
      if (to.meta.clearDataOnRender) {
        delete store.state.data[to.meta.jsonKey];
      }
      store.dispatch("fetchDataOnInit", { to, from });
    }
    if (to.meta && to.meta.title) {
      document.title = to.meta.title;
    }
  });

  sync(store, router);

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
}

if (process.env.NODE_ENV === "development") {
  console.log("開発環境です↓");
  console.log("process.env.NODE_ENV ===", process.env.NODE_ENV);
  console.log(process);
}
